import React from 'react';

import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './contexts/languageContext';
import Enrutador from './router/Enrutador';
import GlobalStyles from './styles/global';
import FormatoColo19 from './styles/formatoColo19';
import 'focus-visible/dist/focus-visible.js';
import styled from 'styled-components/macro';
import useIni, { IniProvider } from "./hooks/useIni";
import { NomenclatorProvider } from "./contexts/nomenclatorContext";
import { PrintProvider } from "./print/Print";

/**
 * Entrada a la aplicación donde inyectamos algunos contextos que se utilizan en toda
 * la aplicación
 */

const Marca = ({ prueba: {esPrueba, texto }}) =>
  esPrueba ? (
    <TextoMarca>{texto}</TextoMarca>
  ) : null;

const App = () => {
  return (
    <BrowserRouter>
      <NomenclatorProvider>
        <IniProvider>
          <PrintProvider>
            <Inner />
          </PrintProvider>
        </IniProvider>
      </NomenclatorProvider>
    </BrowserRouter>
  );
};

export const Inner = () => {
  const ini = useIni();
  return (
    <>
      <Marca prueba={ini.general?.prueba} />
      <LanguageProvider>
        <GlobalStyles />
        <FormatoColo19 />
        <Enrutador />
      </LanguageProvider>
    </>
  );
};

const TextoMarca = styled.div`
  position: sticky;
  height: 0;
  top: 30rem;
  font-size: 10vw;
  opacity: 0.1;
  z-index: 1;
  transform: rotate(-25deg);
  white-space: nowrap;
  user-select: none;
  pointer-events: none;
  @media (max-width: 1024px) {
    transform: rotate(-40deg);
  }
  @media (max-width: 768px) {
    transform: rotate(-45deg);
  }
`;

export default App;
